<template>
  <div class="invoice-page mt-2 mx-16">
    <div class="flex flex-wrap items-center justify-between">
      <vx-input-group class="mb-base mr-3">

        <template slot="append">
          <div class="append-text btn-addon">

          </div>
        </template>
      </vx-input-group>
      <div class="flex items-center" v-if="!is_full_screen">
        <vs-button color="dark" type="border" class="mb-base mr-3" icon-pack="feather" icon="icon icon-file" @click="onClickPrint">Print & Download</vs-button>
      </div>
    </div>
    <vx-card>
      <body id="myelement">
      <div id="full-wrap">
        <main class="clearfix">

          <div id="user" class="clearfix">

            <div id="user-top">

              <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>
                <tr>
                  <td class="head align-left">
                    <img id="logo"
                         src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                         alt="Logo" width="300" height="150" />
                  </td>


                </tr>


                <tr>
                  <td>
                    <table id="main-tbl">
                      <thead class="">
                      <tr>
                        <td colspan="2" class="head">
                          <h4 class="m-0" style="color: #000000"><b>INVOICE</b></h4>
                        </td>
                      </tr>
                      </thead>

                      <tbody>

                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">SHIPPER/EXPORTER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.shipper_address.company_name }}<br>
                                    {{ invoice_data.shipper_address.line_1 }}<br>
                                    {{ invoice_data.shipper_address.line_2 }}<br>
                                    {{ invoice_data.shipper_address.town_state }}<br>
                                    {{ invoice_data.shipper_address.post_code }}<br>
                                    {{ invoice_data.shipper_address.country }}</p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <div>
                                  <p class="sml">Tel. {{ invoice_data.tel || '' }}<br>
                                    Email: {{ invoice_data.email || '' }}<br>
                                    VAT Reg No: {{ invoice_data.vat_reg || '' }}<br>
                                    Company No: {{ invoice_data.company_no || '' }}<br>
                                    EORI for NI: {{ invoice_data.eori_ni || '' }}<br>
                                    EORI for EU: {{ invoice_data.eori_eu || '' }}</p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">INVOICE DATE:</p>
                                  <p class="sml"><b>{{ invoice_data.invoice_date || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">COMMERCIAL INVOICE NO:</p>
                                  <p class="sml"><b>{{ invoice_data.invoice_number || '' }}</b></p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER P.O. NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_order_number || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">ITS ORDER NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.order_code || ''  }}</b></p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">CONSIGNEE</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.customer_address.company_name }}<br>
                                    {{ invoice_data.customer_address.line_1 }}<br>
                                    {{ invoice_data.customer_address.line_2 }}<br>
                                    {{ invoice_data.customer_address.town_state }}<br>
                                    {{ invoice_data.customer_address.post_code }}<br>
                                    {{ invoice_data.customer_address.country }}
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <div>
                                  <p class="sml">
                                    VAT: {{ invoice_data.consignee_vat || 'N/A' }}<br>
                                    EORI: {{ invoice_data.consignee_eori || 'N/A' }}<br>
                                    TSS Reg No: {{ invoice_data.consignee_tss_registration_number || '' }}<br>
                                    TEL: {{ invoice_data.consignee_tel || '' }}<br>
                                    IMPORT LICENCE NO: {{ invoice_data.import_licence_no || 'N/A' }}</p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER ACCOUNT NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_account_number || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">TRANSPORT AWB/REF NUMBER:</p>
                                  <p class="sml">
                                    <b v-for="(ref, index_ref) in invoice_data.transport_ref_number" :key="index_ref">
                                      {{ref}},
                                    </b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">INCOTERMS:</p>
                                  <p class="sml"><b>{{ invoice_data.incoterm }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">TERMS OF PAYMENT:</p>
                                  <p class="sml">
                                    <b v-if="!is_proforma_account">{{ invoice_data.invoice_due_date ? `Payment due on ${invoice_data.invoice_due_date}` : 'N/A' }}</b>
                                    <b v-if="is_proforma_account">Payment upon receipt</b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">DELIVERY SITE</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytd">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.delivery_address.company_name }}<br>
                                    {{ invoice_data.delivery_address.line_1 }}<br>
                                    {{ invoice_data.delivery_address.line_2 }}<br>
                                    {{ invoice_data.delivery_address.town_state }}<br>
                                    {{ invoice_data.delivery_address.post_code }}<br>
                                    {{ invoice_data.delivery_address.country }}
                                  </p>
                                </div>
                              </td>

                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-l-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">FREIGHT DETAILS:</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">
                                <div v-if="invoice_data.package_details.length === 1">
                                  <p class="sml">Cube: {{invoice_data.package_details[0].cube}}<br>
                                    Dimensions: {{invoice_data.package_details[0].dimensions}}<br>
                                    Gross Weight: {{invoice_data.package_details[0].gross_weight}}<br>
                                    Net Weight: {{invoice_data.package_details[0].net_weight}}<br>
                                    No. of Boxes/Pallets: {{invoice_data.package_details[0].no_of_pallets}}<br>
                                  </p>
                                </div>
                                <div v-if="invoice_data.package_details.length > 1">
                                  <p class="sml">This invoice contains products that are on different freight bookings</p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <!--                                <div>-->
                                <!--                                  <p class="sml">Tel. 01635 261920<br>-->
                                <!--                                    Email: sales@itstaste.com<br>-->
                                <!--                                    VAT Reg No: 1234567890<br>-->
                                <!--                                    Company No: 1234567890<br>-->
                                <!--                                    EORI for NI: XI1234567890<br>-->
                                <!--                                    EORI for EU: GB1234567890</p>-->
                                <!--                                </div>-->
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td colspan="2" class="toptd">
                          <table id="content-tbl">
                            <thead>
                            <tr>
                              <th><b>Customer Product Code</b></th>
                              <th><b>Product Code/Name</b></th>
                              <th><b>Quantity(KG)</b></th>
                              <th><b>Commodity Code</b></th>
                              <th><b>Country of Origin</b></th>
                              <th><b>Price Per Unit ({{ invoice_data.account_currency }})</b></th>
                              <th><b>Net Value ({{ invoice_data.account_currency }})</b></th>
                              <th><b>VAT Rate</b></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in invoice_data.order_items" :key="index">
                              <td class="break-normal">
                                {{ item.customer_product_code }}
                              </td>

                              <td class="break-normal">
                                {{ item.product_name_code }}
                              </td>
                              <td>{{ Number(item.quantity) }}</td>
                              <td>{{ item.commodity_code }}</td>
                              <td>{{ item.origin }}</td>
                              <td>{{item.price}}</td>
                              <td>{{ Number(item.net_value).toFixed(2) }}</td>
                              <td>{{ Number(item.vat_value).toFixed(2) }}</td>

                            </tr>
                            <tr>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>

                            </tr>

                            <tr>
                              <td colspan="6" rowspan="4">&nbsp;</td>
                              <td>Item Net Value</td>
                              <td>{{ itemNetValue() }}</td>
                            </tr>
                            <!--                            <tr>-->
                            <!--                              <td>Frieght Cost (20.00%)</td>-->
                            <!--                              <td>12.00</td>-->
                            <!--                            </tr>-->
                            <tr v-for="(cost, index_cost) in invoice_data.additional_costs" :key="index_cost">
                              <td>{{ cost.name }} ({{ cost.percent }}% VAT/Tax)</td>
                              <td>{{ Number(cost.amount).toFixed(2) }}</td>
                            </tr>
                            <tr>
                              <td>Total Order Value <br>(Incl. VAT in {{ invoice_data.account_currency }})</td>
                              <td>{{ totalOrderValue() }}</td>
                            </tr>

                            </tbody>
                          </table>
                        </td>

                      </tr>

                      <tr>
                        <td colspan="2" class="toptd">

                          <table class="no-bd-tbl">
                            <thead>
                            <tr>
                              <td colspan="4">
                                <p>
                                  <br>
                                  The exporter of the products covered by this<br>
                                  document declares that, except where<br>
                                  otherswise clearly indicated, these products
                                  are<br>
                                  of the UK preferential origin<br>
                                  <b>Products: Not edible, Not animal origin
                                  </b>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="2" width="750px">
                                <p>Payment Details<br>
                                  {{ invoice_data.account_currency }} Electronic Payments:-<br>
                                  Bank: {{ invoice_data.bank_details.name }}<br>
                                  Account Name: {{ invoice_data.bank_details.account_name }}<br>
                                  Account Number: {{ invoice_data.bank_details.account_number }} Sort Code: {{ invoice_data.bank_details.sort_code || 'N/A' }}<br>
                                  IBAN: {{ invoice_data.bank_details.iban || 'N/A' }}<br>
                                  SWIFTBIC: {{ invoice_data.bank_details.swiftbi || 'N/A' }}</p>

                              </td>
                              <td>
                                <img v-if="!is_customer_uk" width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/s_jones_signature.png" alt="">
                              </td>
                              <td>
                                <img v-if="!is_customer_uk" width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/its_stamp.bmp" alt="">
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4">
                                <p class="align-center">ITS reserves the right to
                                  charge
                                  interest on late payments<br>
                                  ITS terms and conditions of sale apply.</p>
                              </td>
                            </tr>
                            </thead>
                          </table>
                        </td>

                      </tr>


                      </tbody>
                    </table>
                  </td>
                </tr>









                </tbody>
              </table>



            </div>

          </div>

        </main>


      </div>
      </body>
    </vx-card>
  </div>
</template>

<script>
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import {Printd} from "printd";
const InvoiceRepository = RepositoryFactory.get('invoice')

export default {
  name: "Invoice",
  data() {
    return {
      id: '',
      secret_code: '',
      is_proforma_account: false,
      is_full_screen: false,
      invoice_data: {
        order_items: [],
        additional_costs: [],
        tel: '',
        bank_details: {
          name: '',
          account_name: '',
          account_number: '',
          iban: '',
          sort_code: '',
          swiftbi: ''
        },
        shipper_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        customer_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        delivery_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        }
      },
    }
  },
  async mounted() {
    this.secret_code = this.$route.params.key
    this.is_full_screen = this.$route.query.is_full_screen === null
    await this.getInvoiceDetails()
  },
  methods: {
    async getInvoiceDetails() {
      await this.$vs.loading()
      try {
        const {data} = (await InvoiceRepository.getProductOrderInvoiceData(this.secret_code)).data
        this.invoice_data = data
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close()
    },
    itemNetValue() {
      const total = this.invoice_data.order_items.reduce((a, b) => a + Number(b.net_value) + Number(b.vat_value), 0)
      return Number(total).toFixed(2)
    },
    totalOrderValue() {
      const total_add_cost = this.invoice_data.additional_costs.reduce((a, b) => a + Number(b.amount), 0)
      const total = this.invoice_data.order_items.reduce((a, b) => a + Number(b.net_value) + Number(b.vat_value), 0)
      return Number(total_add_cost + total).toFixed(2)
    },
    onClickPrint() {
      const d = new Printd()
      const styles = `
          html,
body {
  -webkit-print-color-adjust: exact !important;
}
@media print {
  body {
    zoom: 75%;
  }
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table td:nth-child(2) {
  word-break: break-all;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 2em auto 2em auto;
}

div#user-top table {
  margin: 0 auto 0 auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 14px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


table#content-tbl td.htd {
  height: 350px;
}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}
        `
      d.print(document.getElementById('myelement'), [styles])
    }
  },
  mixins: [ErrorMessages, SuccessMessage],
  computed: {
    styleObject: function () {
      const total_item_height = this.invoice_data.order_items.length * 55
      const total_add_cost_line_height = this.invoice_data.additional_costs.length * 100
      const space_height = 300 - (total_item_height + total_add_cost_line_height)
      return {
        height: `${space_height}px`
      }
    },
    is_customer_uk: function () {
      return ['Great Britain', 'Northern Ireland'].includes(this.invoice_data.customer_address.country);
    }
  },
}
</script>

<style lang="scss">
html,
body {
  -webkit-print-color-adjust: exact !important;
}

/*@media print {*/
/*  body {*/
/*    zoom: 50%;*/
/*  }*/
/*}*/

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table td:nth-child(2) {
  word-break: break-all;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 2em auto 2em auto;
}

div#user-top table {
  margin: 0 auto 0 auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 14px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


table#content-tbl td.htd {
  height: 300px;
}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}

</style>
